import * as React from "react";
import { Line } from "react-chartjs-2";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    Data,
    onPeriodOpen,
    periodOpen,
    periodArray,
    onSelectToggle,
    periodText,
  } = props;

  /**
   * @description : Liste des caméras
   * @const
   * @type { any }
   * @name Options
   */
  const Options: any = {
    animation: {
      duration: 0,
      easing: "linear",
    },
    maintainAspectRatio: false, // Don't maintain w/h ratio
    legend: {
      display: false,
    },
    responsive: true,
    scales: {
      xAxes: [
        {
          display: true,
          gridLines: {
            // borderDash:[5, 15, 25],
            display: true,
            lineWidth: 1,
          },
          ticks: {
            min: 0,
          },
          scaleLabel: {
            display: true,
            fontColor: "#00ECBC",
            fontSize: 17,
            labelString: i18next.t("temporalite"),
          },
        },
      ],
      yAxes: [
        {
          display: true,
          gridLines: {
            // borderDash:[5, 15, 25],
            display: true,
            lineWidth: 1,
          },
          ticks: {
            min: 0,
          },
          scaleLabel: {
            display: true,
            fontColor: "#00ECBC",
            fontSize: 17,
            labelString: i18next.t("nombre incident"),
          },
        },
      ],
    },
    tooltips: {
      backgroundColor: "rgba(0,0,0,0.5)",
      bodyFontSize: 14,
      caretSize: 5,
      cornerRadius: 2,
      enabled: true,
      titleFontSize: 0,
      xPadding: 10,
      yPadding: 10,
    },
  };

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */

  return (
    <div className="contentStatistic">
      <div className="chartStats">
        <Line data={Data} options={Options} />
      </div>
      <div className="chartToggle">
        <div className="chartToggleSelect">
          <span onClick={onPeriodOpen}>{periodText}</span>
          {periodOpen && (
            <div className="chartDays animated slideInUp">
              {periodArray.map((elem: any, index: number) => (
                <div
                  className="chartDaystext "
                  key={index}
                  onClick={onSelectToggle(elem, index)}
                >
                  {elem}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onPeriodOpen?: any;
  periodOpen?: any;
  periodArray?: any;
  onSelectToggle?: any;
  Data?: any;
  periodText?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/chart/component.tsx